import React from 'react';

export interface CrossIconProps {
  size?: number;
  color?: string;
  thickness?: number;
}

const CrossIcon = ({
  size = 100,
  color = 'black',
  thickness = 10,
}: CrossIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 10.0693L10.5 1.06934M1.5 1.06934L10.5 10.0693" stroke={color} strokeWidth={thickness} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default CrossIcon;
